import { makeAutoObservable } from 'mobx';

import { ScanIqCurrentSubscriptionInfo } from '../interfaces/customerSubscription';
import { resetAllStore } from '../../shared/stores/resetAllStore';
import {
  PAYMENT_STATUS,
  PaymentStatus,
  PaymentStatusFlags,
} from '../constants/paymentStatus';
import { getFlagsObject } from '../../shared/utils/sortingAndGroupingUtil';
import { scanIqCustomerPaymentService } from '../services/scanIqCustomerPaymentService';

class ScanIqCurrentSubscriptionPlanStore {
  private entityId: number | null = null;
  private customerId: number | null = null;
  currentSubscriptionPlan: ScanIqCurrentSubscriptionInfo | null = null;
  paymentStatusFlag: PaymentStatusFlags = {};

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  setDefaultValues() {
    this.entityId = null;
    this.customerId = null;
    this.currentSubscriptionPlan = null;
    this.paymentStatusFlag = {};
  }

  private setCurrentSubscriptionPlan(currentPlan: ScanIqCurrentSubscriptionInfo) {
    this.currentSubscriptionPlan = currentPlan;
  }

  async getCurrentSubscriptionPlan(entityId: number, customerId: number) {
    const data = await scanIqCustomerPaymentService.getCurrentSubscriptionInfo(
      entityId,
      customerId,
    );

    this.setEntityId(entityId);
    this.setCustomerId(customerId);
    this.setPaymentStatusFlag(data.lastTransaction.status);
    this.setCurrentSubscriptionPlan(data);
  }

  private setPaymentStatusFlag(paymentStatus: PaymentStatus) {
    this.paymentStatusFlag = getFlagsObject(PAYMENT_STATUS, [paymentStatus]);
  }

  async cancelSubscription() {
    if (
      !this.entityId ||
      !this.customerId ||
      !this.currentSubscriptionPlan?.lastTransaction
    ) {
      throw new Error('cancelSubscription miss necessary data');
    }

    await scanIqCustomerPaymentService.cancelSubscription(
      this.entityId,
      this.customerId,
      this.currentSubscriptionPlan.lastTransaction.subscriptionTransactionId,
    );

    this.getCurrentSubscriptionPlan(this.entityId, this.customerId);
  }

  private setEntityId(entityId: number) {
    this.entityId = entityId;
  }

  private setCustomerId(customerId: number) {
    this.customerId = customerId;
  }
}

const scanIqCurrentSubscriptionPlanStore = new ScanIqCurrentSubscriptionPlanStore();
resetAllStore.addResetMethod(scanIqCurrentSubscriptionPlanStore.setDefaultValues);

export { scanIqCurrentSubscriptionPlanStore, ScanIqCurrentSubscriptionPlanStore };
